import type { CoreAddress } from '@/lib/zifekCore';

interface Props {
  addresses: CoreAddress[];
  orgNameById: Record<number, string>;
}

const OWNER_LABELS: Record<string, string> = {
  organization: 'Organisation',
  location: 'Établissement',
  user: 'Utilisateur',
  customer: 'Client',
  supplier: 'Fournisseur',
  order: 'Commande',
  billing: 'Facturation',
  shipping: 'Livraison',
};

export default function AddressesPanel({ addresses, orgNameById }: Props) {
  if (addresses.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-background-50 border border-background-200/70 rounded-lg">
        <div className="w-14 h-14 rounded-full bg-background-100 flex items-center justify-center mb-3">
          <i className="ri-map-pin-2-line text-2xl text-foreground-400"></i>
        </div>
        <p className="text-foreground-600">Aucune adresse.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {addresses.map((a) => (
        <div key={a.id} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
          <div className="flex items-center justify-between gap-3 mb-3">
            <div className="flex items-center gap-2 min-w-0">
              <div className="w-9 h-9 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-2-line"></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-950 truncate">{a.label || 'Adresse'}</div>
                <div className="text-[11px] text-foreground-400">
                  {OWNER_LABELS[a.owner_type] || a.owner_type}
                  {a.owner_type === 'organization' && a.owner_id ? ` · ${orgNameById[a.owner_id] || `#${a.owner_id}`}` : ''}
                </div>
              </div>
            </div>
            {a.is_default && (
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 font-medium whitespace-nowrap">
                Défaut
              </span>
            )}
          </div>

          <div className="text-xs text-foreground-500 space-y-0.5">
            {a.address_line_1 && <div>{a.address_line_1}</div>}
            {a.address_line_2 && <div>{a.address_line_2}</div>}
            <div>{[a.city, a.region, a.postal_code].filter(Boolean).join(', ') || '—'}</div>
            <div className="text-foreground-400">{a.country || '—'}</div>
          </div>
        </div>
      ))}
    </div>
  );
}